import React from 'react'

function SalesInvoiceStatistics() {
  return (
    <div>SalesInvoiceStatistics</div>
  )
}

export default SalesInvoiceStatistics